/**
 * @fileoverview Provides the `Button` component, a styled button with configurable variants and sizes. It uses the `ButtonProps` interface to define the component's properties. Exports the `Button` component.
 */

import React from 'react'
import '../styles/components/button.css'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'upgrade'
  size?: 'small' | 'medium' | 'large'
  children: React.ReactNode
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'secondary', size = 'small', className = '', children, ...props }, ref) => {
    const buttonClasses = ['button', variant, size, className].filter(Boolean).join(' ')

    return (
      <button ref={ref} className={buttonClasses} {...props}>
        {children}
      </button>
    )
  },
)

Button.displayName = 'Button'

export default Button
